export const QUESTIONS = [
  {
    "id": 1,
    "text": "وقتی تو موقعیت سختی می‌افتی، اولین واکنش تو چیه؟",
    "options": [
      {
        "label": "A",
        "text": "می‌رم تو گذشته‌م...",
        "therapist": "freud"
      },
      {
        "label": "B",
        "text": "فکر میکنم یه معنای عمیق‌تر پشتشه.",
        "therapist": "jung"
      },
      {
        "label": "C",
        "text": "نیمه پر لیوان رو میبینم.",
        "therapist": "seligman"
      },
      {
        "label": "D",
        "text": "کلمات «همیشه/هرگز» را حذف می‌کنم و جمله‌ام را دقیق‌تر می‌نویسم.",
        "therapist": "chomsky"
      }
    ]
  },

  {
    "id": 2,
    "text": "برای اینکه توی یه روز تعطیل وقتت رو به خوبی سپری کنی، چیکار می‌کنی؟",
    "options": [
      {
        "label": "A",
        "text": "کتاب فلسفی می‌خونم.",
        "therapist": "maslow"
      },
      {
        "label": "B",
        "text": "با یکی گپ می‌زنم و حس امنیت می‌دم.",
        "therapist": "winnicott"
      },
      {
        "label": "C",
        "text": " اگر طبق برنامه پیش برم عصر به خودم یه ماچا جایزه میدم.",
        "therapist": "skinner"
      },
      {
        "label": "D",
        "text": "سه چیز خوبِ امروز رو می‌نویسم و عصر یه جشن کوچیک با یه دوست می‌گیرم.",
        "therapist": "seligman"
      }
    ]
  },
  {
    "id": 3,
    "text": "دوستات تو رو چه جور آدمی می‌بینن؟",
    "options": [
      {
        "label": "A",
        "text": "کسی که دنبال معنا های بزرگه.",
        "therapist": "frankl"
      },
      {
        "label": "B",
        "text": "باورش زیر سوال بره قاطی می‌کنه!",
        "therapist": "festinger"
      },
      {
        "label": "C",
        "text": "همیشه پازل فلسفی حل می‌کنه.",
        "therapist": "debotton"
      },
      {
        "label": "D",
        "text": "گذشته رو می‌ندازه توی سطل آشغال اما اول بازیافتش می‌کنه.",
        "therapist": "shayegan"
      }
    ]
  },
  {
    "id": 4,
    "text": "برای تغییر بزرگ از کجا شروع می‌کنی؟",
    "options": [
      {
        "label": "A",
        "text": "از کودکی شروع می کنم.",
        "therapist": "freud"
      },
      {
        "label": "B",
        "text": "دنبال رؤیا یا نشانه میگردم.",
        "therapist": "jung"
      },
      {
        "label": "C",
        "text": "برنامه عملی قدم‌به‌قدم میریزم.",
        "therapist": "skinner"
      },
      {
        "label": "D",
        "text": "خودم رو پیدا می‌کنم چون گوگل مپ برای روانم کار نمی‌کنه. ",
        "therapist": "shayegan"
      }
    ]
  },
  {
    "id": 5,
    "text": "یک جمله درباره زندگی بگو:",
    "options": [
      {
        "label": "A",
        "text": "زندگی یعنی رسیدن به قله خود.",
        "therapist": "maslow"
      },
      {
        "label": "B",
        "text": "محیط امن=شکوفایی.",
        "therapist": "winnicott"
      },
      {
        "label": "C",
        "text": "صحبت درست، فکر درست.",
        "therapist": "chomsky"
      },
      {
        "label": "D",
        "text": "زندگی مثل پارکینگ طبقاتی می‌مونه جا نباشه مدام باید دور خودت بچرخی",
        "therapist": "shayegan"
      }
    ]
  },
  {
    "id": 6,
    "text": "وقتی مشکلی ذهنت رو مشغول می‌کنه، چیکار می‌کنی؟",
    "options": [
      {
        "label": "A",
        "text": "باورام رو با واقعیت می‌سنجم.",
        "therapist": "festinger"
      },
      {
        "label": "B",
        "text": "فکر میکنم حتماً درس فلسفی ای توشه.",
        "therapist": "debotton"
      },
      {
        "label": "C",
        "text": "به چشم فرصتی برای معنا میبینمش.",
        "therapist": "frankl"
      },
      {
        "label": "D",
        "text": "باهاش مواجه میشم تا مثل سریال‌های ترکی بیست فصل ادامه پیدا نکنه ",
        "therapist": "shayegan"
      }
    ]
  }
];